import React, { useEffect, useRef, useState } from "react";

import style from "./Order.module.css";

export function OrderBtn(props) {
  let [isOpen, setIsOpen] = useState(false);
  let containerRef = useRef();
  let [selectedType, setSelectedType] = useState(-1); //0 for sale 1 for rent

  function handleClickOutside(ev) {
    if (containerRef.current && !containerRef.current.contains(ev.target)) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function selectType(type, ev) {
    setSelectedType(type);

    props.setFunction(ev);
  }

  return (
    <div className={`${style.container}`} ref={containerRef}>
      <div
        className={`${style.button}`}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        style={{
          paddingLeft: "10px",
        }}>
        <div className={`${style.button_icon}`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style={{ width: "30px", height: "30px" }}>
            <path d="M111 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L49 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM312 480c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H312zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H312zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H312zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H312z" />
          </svg>
        </div>
      </div>
      <div className={`${style.content}`} dir="rtl" hidden={!isOpen}>
        <div id="news" className={`${style.content_item} ${selectedType == 0 ? style.content_item_active : ""}`} onClick={ev => selectType(0, ev)}>
          جدیدترین
        </div>
        <div id="olds" className={`${style.content_item} ${selectedType == 1 ? style.content_item_active : ""}`} onClick={ev => selectType(1, ev)}>
          قدیمی‌ترین
        </div>
        <div id="popular" className={`${style.content_item} ${selectedType == 2 ? style.content_item_active : ""}`} onClick={ev => selectType(2, ev)}>
          پر بازدیدترین
        </div>
      </div>
    </div>
  );
}
